import React, { useState } from "react";
import { TextField, Button, Box, Typography, MenuItem, IconButton, Dialog, DialogContent, DialogTitle, Stack, List, Backdrop, CircularProgress, Select } from "@mui/material";
import { Add, Check, ChurchOutlined, Close, Delete } from "@mui/icons-material";
import { Context } from "../../App";

export default function OffSpe(props) {
    const { region } = React.useContext(Context);
    const [load, setLoad] = useState(false)
    const [open ,SetOpen] = useState(false)
    const [action, setAction] = useState('')
    const [customeSousPoste, setCustomeSP] = useState('') 
    const [index, setIndex] = useState() //pour la creation de sous-poste custome
    const [option, setLabel] = useState()
    const [eglises, setEglises] = useState([])

    function manageDialog(open, action='') {
        SetOpen(open)
        setAction(action)
        if (!open) {
            setCustomeSP('')
            setIndex()
            setLabel()
        }
    }

    function handleSelectLabel(e, index) {
        props.setOffSpe(old => old.map((off, i) => i=== index ? {libelle: e.split(':')[1], montant: off.montant, compte: e.split(':')[0]} : off))
        manageDialog(false);
    }

    function handleAnotherChurch() {
        setLoad(true) //par région
        const query = new URLSearchParams({ region, type:'église' }).toString();
        
        fetch(process.env.REACT_APP_API_URL.concat('/public/eglises/by?'+ query), {method: 'GET'})
        .then((res) => res.json())
        .then((data) => { console.log("Fetched eglises:", data);
        setEglises(data);
        setLoad(false);
        })
        .catch((err) => {
        console.error("Error fetching eglises:", err);
        setLoad(false);
        });
    }

    return(
        <Box display='flex' flexDirection='column' gap={2} sx={{ width: '100%', maxWidth: '100%' }}>
            {props.offSpe.map((offrande, index) =>
            <Stack direction={{ xs: 'column', sm: 'row' }} key={index} gap={1} sx={{alignItems:{ xs: 'stretch', sm: 'center' }, width: '100%'}}>
                
                <TextField select label='Bénéficiaire' size="small" sx={{ width: '100%', maxWidth: '100%', mb: { xs: 0, sm: 0 } }}
                value={ Object.values(offrande).every(value => value === '' || value === 0 || value === null || value === undefined) ? '' : offrande.compte+':'+offrande.libelle}
                onChange={(event)=> handleSelectLabel(event.target.value, index)}>
                    
                    {props.offSpeOptions.sort((a,b)=>a.libelle<b.libelle?-1:1).map((option, optionIndex) => {
                        const items = [
                            <MenuItem key={optionIndex} value={option.num+':'+option.libelle} disabled={props.offSpe.some(off=> off.libelle === option.libelle)} sx={{ py: { xs: 0.25, sm: 1.5 }, px: { xs: 2, sm: 3 } }}>
                                <Typography sx={{textTransform:'capitalize', fontWeight:option.sous_postes?.filter(sp=>sp.activated).length>0||option.customize_sous_postes_activated ? 'bold': 'normal', fontSize: { xs: '0.875rem', sm: '1rem' }, lineHeight: { xs: 1.3, sm: 1.5 }, wordBreak: 'break-word'}}>{option.libelle}</Typography> 
                            </MenuItem>,
                            ...option.sous_postes?.filter(sp=>sp.activated).sort((a,b)=>a.libelle<b.libelle?-1:1).map((sousPoste) => (
                                <MenuItem sx={{marginLeft: { xs: 2, sm: 5 }, paddingBlock:0, marginBlock:0, fontStyle:'italic', py: { xs: 0.125, sm: 1 }, px: { xs: 2, sm: 3 }}} key={option.num+sousPoste.libelle} 
                                value={option.num+':'+sousPoste.libelle} disabled={props.offSpe.some(off=> off.libelle === sousPoste.libelle && off.compte === option.num)}>
                                    <Typography sx={{textTransform:'capitalize', fontSize: { xs: '0.8125rem', sm: '0.875rem' }, lineHeight: { xs: 1.2, sm: 1.4 }, wordBreak: 'break-word'}}>{sousPoste.libelle}</Typography>
                                </MenuItem>
                            ))
                        ]
                        
                        return items
                    }).flat()}

                    {props.isFedOff && (eglises.length>0 ? eglises.sort((a,b)=>a.libelle<b.libelle?-1:1).map((eglise, index) => (
                        <MenuItem key={index} value={eglise.num+':'+eglise.libelle} disabled={props.offSpe.some(off=> off.libelle === eglise.libelle && off.compte === eglise.num)} sx={{ py: { xs: 0.25, sm: 1.5 }, px: { xs: 2, sm: 3 } }}>
                            <Typography sx={{textTransform:'capitalize', fontSize: { xs: '0.875rem', sm: '1rem' }, lineHeight: { xs: 1.3, sm: 1.5 }, wordBreak: 'break-word'}}>{eglise.libelle}</Typography>
                        </MenuItem>))
                    :<Box display='flex' flexDirection='column' alignItems='center' marginTop={1} sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
                        <Button variant="clear" sx={{alignSelf: 'center', fontWeight:'bold', fontSize: { xs: '0.875rem', sm: '1rem' }, px: { xs: 2, sm: 3 }}} onClick={handleAnotherChurch} startIcon={<ChurchOutlined/>}>Autres églises</Button>
                    </Box>)}
                
                </TextField>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: { xs: '100%', sm: 'auto' } }}>
                <TextField label="Montant(en €)" type="number" size="small" sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '100%' }}
                value={offrande.montant} onFocus={()=>{if(offrande.montant===0) props.setOffSpe(old => {old[index].montant = ''; return [...old]})}}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setOffSpe(old => {old[index].montant = Number(e.target.value); return [...old] })
                }else if(e.target.value===''){
                    props.setOffSpe(old => {old[index].montant = ''; return [...old] })
                }}}
                />
                
                {props.offSpe.length>1 && 
                    <IconButton 
                    aria-option="supprimer"
                    sx={{ flexShrink: 0 }}
                    onClick={()=>{
                        props.setOffSpe(old => old.slice(0, index).concat(old.slice(index+1)))
                    }}>
                        <Delete/>
                    </IconButton>
                }
                </Box>
            </Stack>)}

            <Button variant="outlined" sx={{alignSelf:'center', backgroundColor:'white', fontSize: { xs: '0.875rem', sm: '1rem' }, px: { xs: 2, sm: 3 }}} onClick={()=>props.setOffSpe(old=>[...old, {libelle:'', montant:0, compte:''}])} startIcon={<Add/>}>
                Ajouter une offrande spécifiée
            </Button>

            <Dialog open={open} onClose={()=>{manageDialog(false)}} maxWidth={action==='new compte' ? 'xs' : 'sm'} fullWidth={true} PaperProps={{ sx: { mx: { xs: 1, sm: 2 }, width: { xs: 'calc(100% - 16px)', sm: 'auto' } } }}>
                {action==='new SP' && <Stack key={option.num+'customizing'} direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{marginBlock:2, paddingInline: { xs: 1, sm: 2 }, gap: { xs: 2, sm: 1 }}}>
                    <TextField autoFocus fullWidth size="small" label="Libellé" value={customeSousPoste} 
                    onKeyDown={(e)=>{if(e.key==='Enter' && customeSousPoste.length>0) {
                        props.setOffSpeOptions(old=>old.map(item=>(item.libelle+item.num)===(option.libelle+option.num) ? {...option, sous_postes: [...option.sous_postes, {libelle: customeSousPoste, activated: true}]}: item))
                        handleSelectLabel(option.num+':'+customeSousPoste, index)
                    }}}
                    onChange={(e)=>setCustomeSP(e.target.value.toUpperCase())} />
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                    <IconButton variant="contained" disabled={customeSousPoste.length<=0} sx={{ flexShrink: 0 }} onClick={()=>{
                        props.setOffSpeOptions(old=>old.map(item=>(item.libelle+item.num)===(option.libelle+option.num) ? {...option, sous_postes: [...option.sous_postes, {libelle: customeSousPoste, activated: true}]}: item))
                        handleSelectLabel(option.num+':'+customeSousPoste, index)
                    }}><Check fontSize="small" color={customeSousPoste.length>0 ? 'valide': 'inherit'}/></IconButton>
                    <IconButton aria-option="fermer" onClick={()=>manageDialog(false)} sx={{flexShrink: 0}}><Close fontSize="small"/></IconButton>
                    </Box>
                </Stack>}
                {action==='églises' && <>
                    <DialogTitle sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, px: { xs: 2, sm: 3 } }}>Choisir une église</DialogTitle>
                    <DialogContent sx={{ px: { xs: 1, sm: 2 } }}>
                        <List>
                            {load ? <Typography sx={{ textAlign: 'center', py: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>Chargement...</Typography> : eglises.length > 0 ? eglises.map((eglise, index) => (
                                <MenuItem key={index} value={eglise._id} sx={{ py: { xs: 1, sm: 1.5 } }} onClick={()=>{props.setOffSpe(old => old.concat([{libelle: eglise.libelle, montant:0, compte: eglise.num}])); manageDialog(false)}}>
                                    <Typography sx={{textTransform:'capitalize', fontSize: { xs: '0.875rem', sm: '1rem' }}}>{eglise.libelle}</Typography>
                                </MenuItem>
                            )) : <Typography sx={{ textAlign: 'center', py: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>Aucune église trouvée</Typography>}
                        </List>
                    </DialogContent>
                </>}
            </Dialog>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}